/* eslint-disable */
var d3 = require('d3');
/*********** <filter.js> ***********/
   var boxBool = false;
   var filterOptions = {
        filter: [],
        categories: {
            names: []
        },
        catIndicies: {},
        isOrdinal: {},
        sliderMultiplier: 10000,
        sliderPower: 4,

        getCategoryIndex: function(category) {
            return this.catIndicies[category].index;
        },

        getSubCatIndex: function(category, subCategory) {
            return this.catIndicies[category].subCatIndicies[subCategory].index;
        },

        getVisibility: function (dataPoint, categories) {

            for (var i = 0; i < categories._data.length; i++) {
                var category = categories._data[i];
                var catIndex = this.getCategoryIndex(category);

                if (this.isOrdinal[category]) {
                    var subCatIndex = this.getSubCatIndex(category, dataPoint[category]);
                    var filterEntry = this.filter[catIndex][subCatIndex];
                    var isSelected = typeof filterEntry === "object" ? filterEntry.isSelected : filterEntry;
                    if (!isSelected) return false;
                } else {
                    var value = dataPoint[category];
                    if (value < this.filter[catIndex][0].values[0] || value > this.filter[catIndex][0].values[1]) return false;
                }
            }

            return true;
        },

        getCategoryFromIndex: function(categoryIndex) {
            for (var i = 0; i < this.categories.names.length; i++) {
                if (+(categoryIndex) === this.catIndicies[this.categories.names[i]].index) {
                    return this.categories.names[i];
                }
            }

            return null;
        },

        updateOptionsDataStore: function (inputDimensions, data) {
            var categoryInput = inputDimensions.categoryDimensions;
            for (var i = 0; i < categoryInput.length; i++) {
                if (categoryInput[i].isImageCategory) continue;
                this.createDataForDimension(categoryInput[i], data, true);
            }

            var valueInput = inputDimensions.valueDimensions;
            for (var i = 0; i < valueInput.length; i++) {
                this.createDataForDimension(valueInput[i], data, false);
            }
        },

        createDataForDimension: function (dimension, data, ordinal) {
            var outerThis = this;

            var category = dimension.name;
            this.isOrdinal[category] = {};
            this.isOrdinal[category] = ordinal;
            this.filter.push([]);
            this.categories.names.push(category);
            this.categories[category] = {}
            this.categories[category].subCategories = [];
            this.catIndicies[category] = {
                index: +(outerThis.filter.length - 1),
                subCatIndicies: {}
            }
            if (ordinal) {
                var uniqueArray = dimension.order ?
                    dimension.order :
                    arrayGetUnique(data.map(function (d) {
                    return d[category];
                }));
                for (var j = 0; j < uniqueArray.length; j++) {
                    var value = uniqueArray[j];
                    if (value === null) {
                        value = "null";
                        $("#data-warning-alert").css("top", "0");
                        $("#data-warning-alert .alert").addClass("in");
                    }

                    this.filter[this.getCategoryIndex(category)].push(true);
                    this.categories[category].subCategories.push(value);
                    this.catIndicies[category].subCatIndicies[value] = {
                        index: +(outerThis.filter[outerThis.getCategoryIndex(category)].length - 1)
                    }
                }
            } else {
                var values = data.map(function(d) {
                    return d[category];
                });
                var min = Math.min.apply(Math, values), max = Math.max.apply(Math, values), roundTo;
                var range = max - min;
                if (range / 0.01 < 100) {
                    roundTo = 2;
                }
                else if (range / 0.1 < 100) {
                    roundTo = 1;
                } else {
                    roundTo = 0;
                }

                var roundMultiplier = +("1e" + roundTo);
                min = (Math.floor(min * roundMultiplier) / roundMultiplier);
                max = (Math.ceil(max * roundMultiplier) / roundMultiplier);
                this.filter[this.getCategoryIndex(category)].push({
                    values: [min, max],
                    roundTo: roundTo,
                    min: min,
                    max: max,
                    prefix: dimension.valueScaling.scaleFactor == 1 ? dimension.valueScaling.prefix : "",
                    suffix: dimension.valueScaling.scaleFactor == 1 ? dimension.valueScaling.suffix : ""
                });
            }
        },

        getSliderOptions: function(category) {
            if (this.isOrdinal[category]) return null;
            var categoryInfo = this.filter[this.getCategoryIndex(category)][0];
            var step = +("1e" + -categoryInfo.roundTo + this.sliderPower);
            var values = [categoryInfo.values[0] * this.sliderMultiplier, categoryInfo.values[1] * this.sliderMultiplier];

            return {
                animate: "ease-in-out",
                range: true,
                min: categoryInfo.values[0] * this.sliderMultiplier,
                max: categoryInfo.values[1] * this.sliderMultiplier,
                values: values,
                step: step,
                slide: function (event, ui) {
                    var parentSelector = "#" + $(this).parents(".panel-collapse").attr("id");
                    $(parentSelector + " .lower-value input").val(LCP.fn.roundTo(ui.values[0] / filterOptions.sliderMultiplier, categoryInfo.roundTo));
                    $(parentSelector + " .higher-value input").val(LCP.fn.roundTo(ui.values[1] / filterOptions.sliderMultiplier, categoryInfo.roundTo));

                }
            }
        },

        isCategoryActive: function(categoryIndex) {
            if (this.isOrdinal[this.getCategoryFromIndex(categoryIndex)]) {
                for (var i = 0; i < this.filter[categoryIndex].length; i++) {
                    if (!this.filter[categoryIndex][i]) return true;
                }
                return false;
            }

            for (var j = 0; j < this.filter[categoryIndex].length; j++) {
                if (this.filter[categoryIndex][j].values[0] !== this.filter[categoryIndex][j].min || this.filter[categoryIndex][j].values[1] !== this.filter[categoryIndex][j].max) return true;
            }

            return false;
        }
    };

    function arrayGetUnique(a) {
        var output = [];
        for (var i = 0; i < a.length; i++) {
            if (!arrayFind(output, a[i])) output.push(a[i]);
        }
        return output;
    }

    // --- filter options object ---

    var activeCategories = {
        _data: [],

        add: function(category) {
            if (this._data.indexOf(category) >= 0) return;
            this._data.push(category);
        },
        remove: function(category) {
            var index = this._data.indexOf(category);
            if (index < 0) return;
            this._data.splice(index, 1);
        },
        clear: function() {
            this._data = [];
        }
    };

    function getFilterInputId(categoryIndex, valueIndex) {
        return categoryIndex + "_" + valueIndex + "_filter-input";
    }

    function getFilterItemSelector(categoryIndex, valueIndex) {
        return "#" + getFilterInputId(categoryIndex, valueIndex);
    }

    function getOptionsId(categoryIndex) {
        return categoryIndex + "_options";
    }

    function getOptionsSelector(categoryIndex) {
        return "#" + getOptionsId(categoryIndex);
    }

    function getCategoryHeaderId(categoryIndex) {
        return categoryIndex + "_header";
    }

    function getCategoryHeaderSelector(categoryIndex) {
        return "#" + getCategoryHeaderId(categoryIndex);
    }

    function isVisible(dataPoint) {
        if (activeCategories._data.length === 0) return true;
        return filterOptions.getVisibility(dataPoint, activeCategories);
    }

    function setMaxHeight(maxHeight) {
        var heightToUse;

        if (arguments.length !== 1) {
            heightToUse = 500;
        } else {
            heightToUse = maxHeight - 60;
        }

        $("#categories > .panel-body").css("max-height", heightToUse);
        $("#categories > .panel-body").css("overflow", "auto");
    }

    var categoryFilterControl = {
        isVisible: isVisible,
        setMaxHeight: setMaxHeight
    }
/*********** </filter.js> ***********/

/*********** <charting.js> ***********/
    var dataFile;
    var data;

    var defaultAnimationDuration = 1000;
    var animationDuration = defaultAnimationDuration;
    var titleHeight;
    var summaryValuesHeight;
    var boxesData = [];

    var pointClickBeingHandled = false;

    /* layout */
    var selectors = {
        mainChartArea: "#mainChartArea",
        boxSummary: "#boxSummary",
        boxControls: "#summaryControlsSection",
        inputSection: "#inputSection",
        inputAccordianPanel: "#inputAccordianPanel",
        filterSection: "#filterSection",
        inputHeader: "#inputHeader",
        inputPanel: ".inputPanel",
        summaryValues: ".summaryValues"
};


    /* Functionality */
    var zoomAndPan = false;
    var boxSelection = true;
    var includeLabels = true;
    var firstLoad = true;

    // 1: Top left, 2: Top right, 3: Bottom left, 4: Bottom right
    var legendPosition = 2;

    /* Page dimensions */
    var outerWidth;
    var outerHeight;
    var innerWidth;
    var innerHeight;

    var margin = { top: 20, right: 60, bottom: 30, left: 60 };
    var minAxisPaddingMultiplier = 0.9;
    var maxAxisPaddingMultiplier = 1.1;

    /* SVG groups */
    var svg;
    var container;
    var fullScreenBackgroundBox;
    var zoomListener;

    /* Scale functions */
    var scales = { x: "", y: "", r: "", color: "" }

    var rAdditionalSizeOptions = { Enormous: 50, Huge: 20, Large: 10, Medium: 5, Small: 2, Tiny: 1, VTiny: 0.2 };
    var lAdditionalLabelOption = { None: "" };

    /* Axis creators */
    var axis = { x: "", y: ""}

    /* Data dimensions */
    var dimensions = { x: "", y: "", r: "", colorCategory: "", label: "" }
    var previousColorDimension;

    /**
    *  see if object in array?
    * @param {array} a
    * @param {object string} b
    */
    function arrayFind(a, b) {

        for (var i in a) {
            if (a[i] == b) return true;
        }
    }

    /**
    * Shortcut for parseInt
    * @param {Object} s
    */
    function pInt(s, mag) {
        return parseInt(s, mag || 10);
    }

    var defualtOptions = {
        loading: 'Loading...',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July',
            'August', 'September', 'October', 'November', 'December'],
        shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        decimalPoint: '.',
        thousandsSep: ','
    };

    /**
    * Format a number and return a string based on input settings
    * @param {Number} number The input number to format
    * @param {Number} decimals The amount of decimals
    * @param {String} decPoint The decimal point, defaults to the one given in the lang options
    * @param {String} thousandsSep The thousands separator, defaults to the one given in the lang options
    */
    function numberFormat(number, decimals, decPoint, thousandsSep) {
        // http://kevin.vanzonneveld.net/techblog/article/javascript_equivalent_for_phps_number_format/
        var n = number;
        var c = decimals
		var d = decPoint === undefined ? defualtOptions.decimalPoint : decPoint;
		var t = thousandsSep === undefined ? defualtOptions.thousandsSep : thousandsSep, s = n < 0 ? "-" : "";
		var i = String(pInt(n = Math.abs(+n || 0).toFixed(c)));
		var j = i.length > 3 ? i.length % 3 : 0;

        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
		(c>0 ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }

    function arrayGetUniqueValues(a) {
        var output = [];
        for (var i = 0; i < a.length; i++) {
            if (!arrayFind(output, a[i])) output.push(a[i]);
        }
        return output;
    }

    /* Load controls */
    function loadAll() {
        // dataFile = window.DataFile;
        data = dataFile.data;

        initialiseDataFields();
        loadControls();
        loadChart();
        registerEventHandlers();


    }

    function initialiseDataFields() {

        if (data.length > 10000) animationDuration = 0;

        for (var i = 0; i < dataFile.valueDimensions.length; i++) {
            var valueDimension = dataFile.valueDimensions[i];

            dataFile[valueDimension.name] = valueDimension;
            activeCategories._data.push(valueDimension.name);

            for (var j = 0; j < dataFile.data.length; j++) {
                data[j][valueDimension.name] = data[j].values[valueDimension.index] * valueDimension.valueScaling.scaleFactor;
            }

            valueDimension.totalScaling.scaleFactor /= valueDimension.valueScaling.scaleFactor;
            valueDimension.valueScaling.scaleFactor = 1; //All data adjusted to be in terms of the value formating scaling.

        }

        for (var i = 0; i < dataFile.categoryDimensions.length; i++) {
            var categoryDimension = dataFile.categoryDimensions[i];

            dataFile[categoryDimension.name] = categoryDimension;
            activeCategories._data.push(categoryDimension.name);

            for (var j = 0; j < dataFile.data.length; j++) {
                data[j][categoryDimension.name] = data[j].categories[categoryDimension.index];
            }
        }

        dimensions = {
            x: dataFile.initialX,
            y: dataFile.initialY,
            r: dataFile.initialR,
            colorCategory: dataFile.initialColour,
            label: dataFile.initialLabel
        };
        previousColorDimension = dataFile.initialColour;

        includeLabels = dataFile.includeLabels;
    }


    function loadControls() {
        var panelGroup = $("<div>")
            .attr("id", "dimensionAccordian")
            .addClass("panel-group")
            .attr("role", "tablist")
            .attr("aria-multiselectable", "false");

        var categoryGroup = $("<div>")
            .addClass("panel panel-default");

        var filterHeading = $("<div>")
            .addClass("panel-heading")
            .attr("role", "tab")
            .attr("id", "dimensionHeader");

        var link = $("<a>")
            .attr("role", "button")
            .attr("data-toggle", "collapse")
            .attr("data-parent", "#dimensionAccordian")
            .attr("href", "#dimensions")
            .attr("aria-expanded", "true")
            .attr("aria-controls", "categories");
        link.append($("<span>").append($("<i>").addClass("fa fa-cubes fa-fw").attr("aria-hidden", "true"))).append($("<span>").addClass("section-header").html("Dimensions"));

        filterHeading.append(link);
        categoryGroup.append(filterHeading);

        var filterOptionsOuter = $("<div>")
            .attr("id", "dimensions")
            .addClass("panel-collapse collapse in")
            .attr("role", "tabpanel")
            .attr("aria-labelledby", "dimensionHeader");

        var filterOptionsInner = $("<div>")
            .addClass("panel-body")
            .attr("id", selectors.inputAccordianPanel.replace("#", ""));

        filterOptionsOuter.append(filterOptionsInner);
        categoryGroup.append(filterOptionsOuter);
        panelGroup.append(categoryGroup);
        $(selectors.inputSection).append(panelGroup);

        loadDimensionCombo("X axis", "xAxisInput", dataFile.valueDimensions, dimensions.x, onAxisChnaged);
        loadDimensionCombo("Y axis", "yAxisInput", dataFile.valueDimensions, dimensions.y, onAxisChnaged);
        loadDimensionCombo("Size", "rAxisInput", dataFile.valueDimensions, dimensions.r, onAxisChnaged, rAdditionalSizeOptions);
        loadDimensionCombo("Colour", "colourInput", dataFile.categoryDimensions, dimensions.colorCategory, onAxisChnaged);
        if (includeLabels) loadDimensionCombo("Label", "labelInput", dataFile.categoryDimensions, dimensions.label, onAxisChnaged, lAdditionalLabelOption);


        // categoryFilterControl.addControl(selectors.filterSection, dataFile, data);
        filterOptions.updateOptionsDataStore(dataFile, data);
        $("#dimensionAccordian").on("shown.bs.collapse hidden.bs.collapse", function(event) {
            setFilterSectionMaxHeight();
        });

    }

    function loadDimensionCombo(title, id, dimensions, initialValue, onChangeEvent, additionalOptions) {
        var div = $("<div>");
        div.addClass("row");
        div.addClass("comboRow");

        var titleDiv = $("<div>");
        titleDiv.addClass("col-md-3 input-title");

        titleDiv.html(title);
        div.append(titleDiv);

        var comboDiv = $("<div>");
        comboDiv.addClass("col-md-9");
        var combo = $("<form>");
        var select = $("<select>");
        select.attr("class", "dropDownList");

        var group = typeof dimensions[0].isImageCategory !== "undefined";
        if (group) {
            var imageCategories = dimensions.map(function(d) {
                return d.isImageCategory;
            });
            var unique = arrayGetUniqueValues(imageCategories);

            if (unique.length === 1 && unique[0] === false) group = false;
        }

        var parent = !group ? select : $("<optgroup>").attr("label", "User defined");

        for (var i = 0; i < dimensions.length; i++) {
            var valueDimension = dimensions[i];
            if (group && valueDimension.isImageCategory) continue;

            var option = $("<option>");
            option.html(valueDimension.name);
            option.attr("value", valueDimension.name);
            parent.append(option);
        }

        if (group) {
            select.append(parent);

            var imageGroup = $("<optgroup>").attr("label", "Images");

            for (var i = 0; i < dimensions.length; i++) {
                var valueDimension = dimensions[i];
                if (!valueDimension.isImageCategory) continue;

                var option = $("<option>");
                option.html(valueDimension.name);
                option.attr("value", valueDimension.name);
                imageGroup.append(option);
            }
            select.append(imageGroup);
        }

        if (additionalOptions == null) additionalOptions = {};

        for (var property in additionalOptions) {
            var option = $("<option>");
            option.html(property);
            option.attr("value", property);
            select.append(option);
        }

        select.val(initialValue);
        select.attr("id", id);
        select.on("change", onChangeEvent);

        comboDiv.append(combo);
        combo.append(select);

        div.append(comboDiv);

        $(selectors.inputAccordianPanel).append(div);
    }

    function getXaxisSelection() {
        var value = getComboValue("xAxisInput");
        return value;
    }

    function getYaxisSelection() {
        return getComboValue("yAxisInput");
    }

    function getRaxisSelection() {
        return getComboValue("rAxisInput");
    }

    function getColourSelection() {
        return getComboValue("colourInput");
    }

    function getLabelSelection() {
        return getComboValue("labelInput");
    }

    function getComboValue(id) {
        return $("#" + id).val();
    }

    function loadBoxControls() {
        $(selectors.boxControls + " .removeableControl").remove();

        var controls = $(selectors.boxControls +" ul");

        var deleteButton = $("<li>").addClass("removeableControl").append($("<i>").addClass("fa fa-trash-o"));;
        var zoomButton = $("<li>").addClass("removeableControl").append($("<i>").addClass("fa fa-expand"));
        var zoomOutButton = $("<li>").addClass("removeableControl").append($("<i>").addClass("fa fa-compress"));

        deleteButton.on("click", deleteSelectedBox);
        $(document).keyup(function (e) {
            if (e.keyCode === 8 || e.keyCode === 46) {
                deleteSelectedBox();
            }
        });
        zoomButton.on("click", zoomToSelectedBox);
        zoomOutButton.on("click", resetZoom);

        controls.append(deleteButton)
            .append(zoomOutButton)
            .append(zoomButton);

        //$(selectors.boxControls).append(controls);
    }

    /* Initial load */
    function loadChart() {

        titleHeight = 0;
        if (dataFile["title"]) {
            $("#mainChartArea").append($("<h3>").addClass("chart-title").text(dataFile["title"]));
            titleHeight = $(".chart-title").outerHeight(true);
        }

        updateChartDimensions();

        initialiseScales();
        setDomain();

        d3.select(selectors.mainChartArea).classed("plotArea", true);

        svg = d3.select(".plotArea")
            .append("svg")
            //.attr("transform", "translate(0, " + topTranslate + ")")
            .attr("width", outerWidth)
            .attr("height", outerHeight)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        container = svg;

        container.call(zoomListener);

        container.on("mousedown", handleMouseDown)
                 .on("mouseup", handleMouseUp);

        if (!zoomAndPan) {
            disableUserZoom();
        }

        //Container so that all space includes an SVG element
        fullScreenBackgroundBox = svg.append("rect")
        .attr("width", innerWidth)
        .attr("height", innerHeight)
        .attr("class", "chartBackground");

        renderAxis();
        renderBoxes();
        renderData();
        renderLegend();

        populateSummaryValuesForBox(fullScreenBackgroundBox);
    }

    function updateChartDimensions() {

        outerWidth = $(selectors.mainChartArea).innerWidth() - 20;
        outerHeight = $(selectors.mainChartArea).innerHeight() - 20;

        innerWidth = outerWidth - margin.left - margin.right;
        innerHeight = outerHeight - margin.top - margin.bottom;
        if (dataFile["title"]) {
            outerHeight -= titleHeight;
            innerHeight -= titleHeight;
        }
    }

    function initialiseScales() {

        scales.x = d3.scale.linear()
            .range([0, innerWidth]);

        scales.y = d3.scale.linear()
            .range([innerHeight, 0]);

        scales.r = d3.scale.sqrt()
            .range([0, 20]);

    }

    function setAxisDomain(dimension, axis) {

        if (rAdditionalSizeOptions[dimension] != null) {
            axis.domain([0, 20]);
            return;
        }

        var minMax = d3.extent(data, function (d) { return d[dimension] });

        var range = (minMax[1] - minMax[0]);
        var padding = 0.05 * range;

        if (axis === scales.r && range === 0) {
            axis.domain([0, minMax[1] > 0 ? minMax[1] * 2 : 1]);
            return;
        }

        if (minMax[0] >= 0) minMax[0] = Math.max(0, minMax[0] - padding);
        else minMax[0] -= padding; // minMax[0] *= minMax[0] > 0 ?   minAxisPaddingMultiplier : maxAxisPaddingMultiplier;
        //minMax[1] += padding; //minMax[1] *= minMax[1] > 0 ? maxAxisPaddingMultiplier : minAxisPaddingMultiplier;

        if (minMax[1] <= 0) minMax[1] = Math.min(0, minMax[1] + padding);
        else minMax[1] += padding;

        //minMax[0] *= minMax[0] > 0 ?   minAxisPaddingMultiplier : maxAxisPaddingMultiplier;
        //minMax[1] *= minMax[1] > 0 ? maxAxisPaddingMultiplier : minAxisPaddingMultiplier;

        axis.domain(minMax).nice();
    }


    function setDomainForXandY() {
        var isMap = dimensions.x.toLowerCase().indexOf("lon") != -1
                    && dimensions.y.toLowerCase().indexOf("lat") != -1;

        setAxisDomain(dimensions.x, scales.x);
        setAxisDomain(dimensions.y, scales.y);

        if (isMap) {
            var rangeXrange = +scales.x.range()[1] - +scales.x.range()[0];
            var rangeYrange = +scales.y.range()[0] - +scales.y.range()[1];
            var rangeXdomain = +scales.x.domain()[1] - +scales.x.domain()[0];
            var rangeYdomain = +scales.y.domain()[1] - +scales.y.domain()[0];
            var xMidDomain = +scales.x.domain()[0] + 0.5 * rangeXdomain;
            var yMidDomain = +scales.y.domain()[0] + 0.5 * rangeYdomain;

            var yratio = rangeYdomain / rangeYrange;
            var xratio = rangeXdomain / rangeXrange;
            var degreeLongPerLat = 1 / Math.cos(yMidDomain * (2 * Math.PI / 360));
            var desidedXratio = yratio * degreeLongPerLat;
            var desidedYratio = xratio / degreeLongPerLat;

            if (desidedXratio > xratio) {

                var newXDomainMin = xMidDomain - 0.5 * desidedXratio * rangeXrange;
                var newXDomainMax = xMidDomain + 0.5 * desidedXratio * rangeXrange;
                scales.x.domain([newXDomainMin, newXDomainMax]);
            }

            if (desidedYratio > yratio) {

                var newYDomainMin = yMidDomain - 0.5 * desidedYratio * rangeYrange;
                var newYDomainMax = yMidDomain + 0.5 * desidedYratio * rangeYrange;
                scales.y.domain([newYDomainMin, newYDomainMax]);
            }
        }

    }

    function setDomain() {

        setDomainForXandY();
        setDomainsWithoutZoom();

        zoomListener = d3.behavior.zoom()
            .x(scales.x)
            .y(scales.y)
            .scaleExtent([1, 10])
            .on("zoom", zoomHandler);
    }

    function setDomainsWithoutZoom() {
        setAxisDomain(dimensions.r, scales.r);

        if (dataFile[dimensions.colorCategory]  && dataFile[dimensions.colorCategory].colors) {
            scales.color = d3.scale.ordinal()
                .range(dataFile[dimensions.colorCategory].colors);

        } else {
            scales.color = d3.scale.category10();
        }

        if (dataFile[dimensions.colorCategory] && dataFile[dimensions.colorCategory].order) {
            scales.color.domain(dataFile[dimensions.colorCategory].order);
        } else {
            var domain = arrayGetUniqueValues(data.map(function (d) { return d[dimensions.colorCategory]; }));
            if (domain.length === 0 || (domain.length === 1 && typeof domain[0] === "undefined") || dataFile[dimensions.colorCategory].isImageCategory) return;
            scales.color.domain(domain);
        }
    }

    /* Rendering */

    function updateDataItems() {
        var xDomain = scales.x.domain();
        var yDomain = scales.y.domain();

        $.each(data,
            function (i, v) {
                v.xVal = v[dimensions.x];
                v.yVal = v[dimensions.y];
                v.xR = scales.x(v.xVal);
                v.yR = scales.y(v.yVal);

                if (v.xVal < xDomain[0] || v.xVal > xDomain[1] || v.yVal < yDomain[0] || v.yVal > yDomain[1]) {
                    v.rVal = 0;
                }
                else {
                    v.rVal = v[dimensions.r];
                };

                if (v.rVal == null) v.rVal = rAdditionalSizeOptions[dimensions.r]; //If not a property its a size;

                v.rR = scales.r(v.rVal);

                if (v[dimensions.label] != null) v.label = (v[dimensions.label]);
                else v.label = "";

                v.colorCategory = dimensions.colorCategory;
            });
    }

    function renderData() {
        clearPopovers();
        updateDimensions();
        updateDataItems();

        if (enforceDelay()) cleanUp();

        if (firstLoad || !enforceDelay()) {
            plotChart();
        } else {
            setTimeout(plotChart, animationDuration);
        }

        var boxToUse = d3.selectAll(".selectedBox").size() < 1 ? fullScreenBackgroundBox : d3.select(".selectedBox");
        populateSummaryValuesForBox(boxToUse);
    }

    function enforceDelay() {
        if (!dataFile[previousColorDimension]) return false;
        return false; //dataFile[previousColorDimension].isImageCategory !== dataFile[dimensions.colorCategory].isImageCategory;
    }

    function plotChart() {

        if (enforceDelay()) {
            $("defs").remove();
            $(".imageHolders").remove();
        }

        var xStart = scales.x(scales.x.domain()[0]);
        var yStart = scales.y(scales.y.domain()[0]);
/*
        if (!dataFile[dimensions.colorCategory].isImageCategory) {
            plotByCategory();
        } else {
            plotByImage();
        }
*/
plotByCategory();
        if (includeLabels) {

            var labels = container.selectAll(".chartLabels")
                .data(data);

            var labelLines = container.selectAll(".labelLines")
                .data(data);

            labels.enter()
                .append("text").attr("class", "chartLabels")
                .attr("x", xStart)
                .attr("y", yStart)
                .attr("opacity", 0);

            labelLines.enter()
                .append("line").attr("class", "labelLines")
                .attr("x1", xStart)
                .attr("y1", yStart)
                .attr("x2", xStart)
                .attr("y2", yStart);

            calculateLabelPositions();
            updateLabelPositions();
        }

        if (firstLoad) firstLoad = false;
        previousColorDimension = dimensions.colorCategory;

    }

    function plotByCategory() {
        var xStart = scales.x(scales.x.domain()[0]);
        var yStart = scales.y(scales.y.domain()[0]);

        var dots = container.selectAll(".dot")
               .data(data);

        dots.enter()
            .append("circle")
            .attr("class", function (d) { return "dot"; })
            //.attr("r", 2.5)
            .attr("stroke-width", 0)
            .style("opacity", 0.5)
            .attr("r", 0)
            .attr("cx", function (d) {
                return firstLoad ? xStart : d.xR;
            })
            .attr("cy", function (d) {
                return firstLoad ? yStart : d.yR;
            })
            .style("fill", function (d) {
                //if (!dataFile[d.colorCategory].isImageCategory) return scales.color(d[d.colorCategory]);
                //else
                return "white";
            })
            .style("visibility", function(d) {
                if (!categoryFilterControl.isVisible(d)) return "hidden";
                return "visible";
            })
            .on('mousedown', function (d, i) {
                pointClickBeingHandled = true;
                addPopUp(this);
            });

        dots
            .transition()
            //.ease("linear")
            .duration(animationDuration)
            //.delay(function(d,i) { return (i % 5) / 10 * animationDuration; })
            .attr("cx", function (d) { return d.xR; })
            .attr("cy", function (d) { return d.yR; })
            .attr("r", function (d) { return d.rR; })
            .style("fill", function (d) {
                return scales.color(d[d.colorCategory]);
            })
            .style("visibility", function(d) {
                if (!categoryFilterControl.isVisible(d)) return "hidden";
                return "visible";
            });

        dots.exit().remove();
    }

    function plotByImage() {
        var xStart = scales.x(scales.x.domain()[0]);
        var yStart = scales.y(scales.y.domain()[0]);

        var imageHolders = container.selectAll(".imageHolders")
            .data(data)
            .enter()
            .append("g")
            .attr("class", "imageHolders")
            .style("clip-path", function(d, i) {
                return "url(#path" + i + ")";
            });

        container.selectAll("defs").data(data).enter().append("defs")
                .append("svg:clipPath")
                .attr("id", function (d, i) {
                    return "path" + i;
                }).append("rect")
                .attr("width", function (d) {
                    return firstLoad ? 1 : d.xR * 2;
                })
                .attr("height", function(d) {
                    return firstLoad ? 1 : d.xR * 2;
                })
                .attr("x",
                    function (d) {
                        return firstLoad ? xStart : d.xR;
                    })
                .attr("y",
                    function (d) {
                        return firstLoad ? yStart : d.yR;
                    })
                .attr("class", "clipBoxes");


        imageHolders.append("image")
            .attr("x", function (d) {
                return firstLoad ? xStart : d.xR;
            })
            .attr("y", function (d) {
                return firstLoad ? yStart : d.yR;
            })
            .attr("width", function (d) {
                return 1;
            })
            .attr("height", function (d) {
                return 1;
            })
            .attr("xlink:href", function (d) {
                return d[d.colorCategory];
            })
            .attr("class", "images")
            .on('mousedown', function (d, i) {
                pointClickBeingHandled = true;
                addPopUp(this);
            });

        imageHolders = container.selectAll(".imageHolders").data(data);
        var images = container.selectAll(".images")
                        .data(data);
        var boxes = container.selectAll(".clipBoxes")
           .data(data);

        imageHolders.transition()
            .duration(animationDuration)
            .style("visibility", function(d) {
                if (!categoryFilterControl.isVisible(d)) return "hidden";
                return "visible";
            });

        images.transition()
            .duration(animationDuration)
            .attr("x",
                function(d) {
                    return -d.rR + d.xR;
                })
            .attr("y",
                function(d) {
                    return -d.rR + d.yR;
                })
            .attr("width",
                function(d) {
                    return d.rR * 2;
                })
            .attr("height",
                function(d) {
                    return d.rR * 2;
                });

        boxes.transition().duration(animationDuration)
            .attr("x", function(d) { return d.xR - d.rR; })
            .attr("y", function(d) { return d.yR - d.rR; })
            .attr("width", function(d) { return d.rR * 2; })
            .attr("height", function (d) { return d.rR * 2 });

    }

    function cleanUp() {

        container.selectAll(".images").data({})
            .exit()
            .transition()
            .duration(animationDuration)
            .attr("x", function(d) {
                return d.xR;
            })
            .attr("y", function(d) {
                return d.yR;
            })
            .attr("height", 0)
            .attr("width", 0)
            .remove();
        container.selectAll(".clipBoxes").data({})
            .exit()
            .transition()
            .duration(animationDuration)
            .attr("x", function (d) {
                return d.xR;
            })
            .attr("y", function (d) {
                return d.yR;
            })
            .attr("height", 0)
            .attr("width", 0)
            .remove();

        container.selectAll(".dot").data({})
            .exit()
            .transition()
            .duration(animationDuration)
            .attr("r", 0)
            .remove();
    }

    function calculateLabelPositions()
    {
        var labArray = [];
        var ancArray = [];

        $.each(data,
            function (i, v) {
                if (v.label != null) {
                    labArray.push({ x: v.xR, y: v.yR, width: 100, height: 50, name: v.label, point: v });
                    ancArray.push({ x: v.xR, y: v.yR, r: v.rR });
                }
            });

        d3.labeler()
            .label(labArray)
            .anchor(ancArray)
            .width(innerWidth - 100)//To avoind the legend
            .height(innerHeight - 100)
            .start(100);

        $.each(labArray,
            function (i, v) {
                v.point.xL = v.x;
                v.point.yL = v.y;
            });
    }

    function updateLabelPositions() {
        var labels = container.selectAll(".chartLabels")
        .data(data);
        var labelLines = container.selectAll(".labelLines")
        .data(data);

        labels
            .transition()
            .duration(animationDuration)
            .text(function (d) { return d.label })
            .attr("x", function (d) { return d.xL; })
            .attr("y", function (d) { return d.yL; })
            .attr("opacity", 1);

        labelLines
            .transition()
            .duration(animationDuration)
            .text(function (d) { return d.label })
            .attr("x1", function (d) { return d.xR; })
            .attr("y1", function (d) { return d.yR; })
            .attr("x2", function (d) { return d.xL; })
            .attr("y2", function (d) { return d.yL; })
            // TODO: this will currently not work when selecting images
            .attr("stroke",
                function (d) {return d.colorCategory;})
            .attr("stroke-width",
                function (d) {
                    if (d.label == "") return 0;
                    return 2;
                });

        labels.exit().remove();
        labelLines.exit().remove();
    }

    function renderBoxes() {
        var boxes = container.selectAll(".box")
            .data(boxesData);

        boxes.enter()
            .append("rect")
            .attr("class", function (d) { return "box"; })
            .attr("x", function (d) { return scales.x(d.xFrom); })
            .attr("width", function (d) { return scales.x(d.xTo) - scales.x(d.xFrom); })
            .attr("y", function (d) { return scales.y(d.yTo); })
            .attr("height", function (d) { return scales.y(d.yFrom) - scales.y(d.yTo); })
           .attr("boxIndex", function (d,i) { return d.boxIndex; });

        boxes
            .transition()
            .duration(animationDuration)
            .attr("x", function(d) { return scales.x(d.xFrom); })
            .attr("width", function(d) { return scales.x(d.xTo) - scales.x(d.xFrom); })
            .attr("y", function(d) { return scales.y(d.yTo); })
            .attr("height", function(d) { return scales.y(d.yFrom) - scales.y(d.yTo); });


        boxes.exit().remove();
    }

        function renderLegend() {

            var legendBoxSize = 20;
            var padding = 2;
            var rowHeight = legendBoxSize + padding;
            var offsetLeft = -30;

            var legend = container.selectAll(".legend")
                .data(scales.color.domain())
                .enter()
                .append("g")
                .attr("class", "legend")
                .attr("transform", function (d, i) {
                    switch (legendPosition) {
                        case 1:
                        case 2:
                            return "translate(0," + (padding + i * rowHeight) + ")";

                        default:
                            return "translate(0," + (innerHeight + padding + (-scales.color.domain().length + i) * rowHeight) + ")";
                    }
                });

            legend.append("rect")
                .attr("x", function() {
                    switch (legendPosition) {
                    case 1:
                    case 3:
                        return padding;

                    case 2:
                    case 4:
                    default:
                        return innerWidth - offsetLeft - legendBoxSize - padding;
                    }
                })
            .attr("width", legendBoxSize)
            .attr("height", legendBoxSize)
            .style("fill", scales.color);

        legend.append("text")
            .attr("x", function () {
                switch (legendPosition) {
                    case 1:
                    case 3:
                        return legendBoxSize + padding * 3;

                    case 2:
                    case 4:
                    default:
                        return innerWidth - legendBoxSize - offsetLeft - padding * 3;
                }
            })
            .attr("y", legendBoxSize / 2)
            .attr("dy", ".35em")
            .attr("class", "chartText")
            .style("text-anchor", function () {
                switch (legendPosition) {
                    case 1:
                    case 3:
                        return "start";

                    default:
                        return "end";
                }
            })
            .text(function (d) { return d; });
    }

    function renderAxis() {

        var xTransform = scales.y(Math.max(scales.y.domain()[0], Math.min(scales.y.domain()[1], 0)));
        var yTransform = scales.x(Math.max(scales.x.domain()[0], Math.min(scales.x.domain()[1], 0)));
        var xAboveHalfY = 0 > scales.y.domain()[0] + (scales.y.domain()[1] - scales.y.domain()[0]) / 2;
        var yAboveHalfX = 0 > scales.x.domain()[0] + (scales.x.domain()[1] - scales.x.domain()[0]) / 2;
        var xOrient, yOrient;
        if (yAboveHalfX) {
            yOrient = "right";
            if (xAboveHalfY) {
                xOrient = "top";
                legendPosition = 3;
            } else {
                xOrient = "bottom";
                legendPosition = 1;
            }
        } else {
            yOrient = "left";
            if (xAboveHalfY) {
                xOrient = "top";
                legendPosition = 4;
            } else {
                xOrient = "bottom";
                legendPosition = 2;
            }
        }

        axis.x = d3.svg.axis()
            .scale(scales.x)
            .orient(xOrient);

        axis.y = d3.svg.axis()
            .scale(scales.y)
            .orient(yOrient);

        var gxAxis = container.append("g")
            .attr("class", "x axis chartText")
            // used to use innerHeight below
            .attr("transform", "translate(0," + xTransform + ")")
            .call(axis.x)
            .append("text")
            .attr("class", "chartText")
            .attr("x", yOrient === "right" ? 0 : innerWidth)
            .attr("y", -6 * (xOrient === "bottom" ? 1 : -2.5))
            .style("text-anchor", yOrient === "right" ? "start" : "end");

        var gyAxis = container.append("g")
            .attr("class", "y axis chartText")
            .attr("transform", "translate("+ yTransform + ", 0)")
            .call(axis.y)
            .append("text")
            .attr("class", "chartText")
            .attr("transform", "rotate(-90)")
            .attr("y", 6 * (yOrient === "left" ? 1 : -2.5))
            .attr("x", xOrient === "bottom" ? 0 : -innerHeight)
            .attr("dy", ".71em")
            .style("text-anchor", xOrient === "bottom" ? "end" : "start");

        gxAxis.text(getAxisTitle(dimensions.x));
        gyAxis.text(getAxisTitle(dimensions.y));
    }

    function getAxisTitle(dimensionName) {
        var scaling = dataFile[dimensionName].valueScaling;

        var label = "";
        if (scaling.prefix != null) label += scaling.prefix;
        if (scaling.suffix != null) label += scaling.suffix;

        if(label.length >0) return dimensionName + " (" +label+")";
        return dimensionName;
    }

    /* Updates */

    function onAxisChnaged() {
        resetZoom();
        updateDimensions();
        $(".axis").remove();
        $(".legend").remove();
        boxesData.length = 0;
        setDomain();
        renderData();
        renderBoxes();
        renderAxis();
        renderLegend();
    }

    function onDimensionChange() {
        updateDimensions();
        $(".legend").remove();
        $('.axis').remove();
        setDomain();
        renderData();
        renderLegend();
        renderAxis();
    }

    function updateDimensions() {
        dimensions.x = vm.$store.getters.getXaxisSelection;
        dimensions.y = vm.$store.getters.getYaxisSelection;
        dimensions.r = vm.$store.getters.getRaxisSelection;
        dimensions.colorCategory = vm.$store.getters.getColourSelection;
        // if (includeLabels) dimensions.label = getLabelSelection();
        // if (typeof previousColorDimension === "undefined") previousColorDimension = getColourSelection();
    }

    /* Box selection */

    var boxIdCount = 0;

    function mouseDownBoxSelect(sender) {
        var m = d3.mouse(sender);
        unselectAllBoxes();
        container.append("rect")
            .attr("class", "box beingCreated")
            .attr("boxId", boxIdCount)
            .attr("x", m[0])
            .attr("y", m[1])
            .attr("xstart", m[0])
            .attr("ystart", m[1])
            .attr("width", 1)
            .attr("height", 1);
        boxIdCount++;
        container.on("mousemove", mousemove);
    }

    function mousemove() {
        var currentBox = d3.select(".beingCreated");

        var m = d3.mouse(this);
        currentBox.attr("width", Math.abs(currentBox.attr("xstart") - m[0]))
                  .attr("height", Math.abs(m[1] - currentBox.attr("ystart")))
                  .attr("x", Math.min(currentBox.attr("xstart"), m[0]))
                  .attr("y", Math.min(m[1], currentBox.attr("ystart")));
    }

    $(window).mouseup(function () {
        handleMouseUp();
    });
/// FIND ME /////
    function mouseUpBoxSelect(sender) {
        var currentBox = d3.select(".beingCreated");
        if(currentBox[0][0] !== null) {
            if (currentBox.attr("width") < 20 || currentBox.attr("height") < 20) {
                currentBox.remove();
                var m = d3.mouse(sender);
                selectBoxFromMousePosition(m);
            } else {
                currentBox.classed("beingCreated", false);
                currentBox.classed("selectedBox", true);
                boxBool = true;
                vm.$store.commit('updateBoxBool', boxBool);
                var newBox = {
                    xFrom: scales.x.invert(currentBox.attr("x")),
                    xTo: scales.x.invert(+currentBox.attr("x") + +currentBox.attr("width")),
                    yFrom: scales.y.invert(+currentBox.attr("y") + +currentBox.attr("height")),
                    yTo: scales.y.invert(currentBox.attr("y")),
                    boxId: currentBox.attr("boxId")
                            }

                boxesData.push(newBox);
                renderBoxes();
            }

        }
        container.on("mousemove", null);
    }

    function selectBox(rect) {
        unselectAllBoxes();
        rect.classed("selectedBox", true);
        boxBool = true;
        vm.$store.commit('updateBoxBool', boxBool);
        loadBoxControls();
        populateSummaryValuesForBox(rect);
    }

    function unselectAllBoxes() {
        d3.selectAll(".box").classed("selectedBox", false);
        boxBool = false;
        vm.$store.commit('updateBoxBool', boxBool);
    }

    function clearDiv(id) {
        $(id).empty();
    }

    function populateSummaryValuesForBox(box) {

        var summaryValues = getSummaryValuesForBox(box);
        vm.$store.commit('updateAverageTotal', summaryValues);
        setFilterSectionMaxHeight();
    }

    function getSummaryValuesForBox(box) {

        var output = new Object();

        var pointsInBox = getDataPointsInBox(box);
        var count = pointsInBox.length;
        var dimensions = dataFile.valueDimensions;

        output["Count"] = count;

        for (var dimension in dimensions) {
            dimension = dimensions[dimension];
            var dimensionName = dimension.name;
            var sum = sumDimension(pointsInBox, dimensionName);
            var average = sum / count;

            if (dimension.includeTotal) output["Total " + dimensionName] = formatValue(sum, dimension.totalScaling);
            if (dimension.includeAverage) output["Average " + dimensionName] = formatValue(average, dimension.valueScaling);
        }

        return output;
    }

    function formatValue(value, scaling) {

        value *= scaling.scaleFactor;

        var textValue = numberFormat(value, scaling.decimalPlaces);

        if (scaling.prefix != null) textValue = scaling.prefix + textValue;
        if (scaling.suffix != null) textValue = textValue + scaling.suffix;
        return textValue;
    }

    function sumDimension(points, dimension) {
        var total = 0;
        points.forEach(function (d) { total += d[dimension] });
        return total;
    }

    function getDataPointsInBox(box) {

        var xMin = scales.x.invert(+box.attr("x"));
        var xMax = scales.x.invert(+box.attr("x") + +box.attr("width"));
        var yMin = scales.y.invert(+box.attr("y") + +box.attr("height"));
        var yMax = scales.y.invert(+box.attr("y"));

        var pointsInBox = [];

        data.forEach(function (d) {
            var xVal = d.xVal;
            var yVal = d.yVal;
            if ((xVal <= xMax) && (xVal >= xMin) && (yVal <= yMax) && (yVal >= yMin) && categoryFilterControl.isVisible(d)) pointsInBox.push(d);
        });

        return pointsInBox;
    }

    function selectBoxFromMousePosition(m) {

        var xVal = m[0];
        var yVal = m[1];

        var closestBox;
        var closetdistance = 10000000;

        d3.selectAll(".box").each(function (d) {
            var  rect = d3.select(this);

            if (isPointInBox(rect, xVal, yVal)) {
                var distance = Math.abs(xVal - rect.attr("x")) + Math.abs(yVal - rect.attr("y"));
                if (distance < closetdistance) {
                    closestBox = rect;
                    closetdistance = distance;
                }
            }
        });

        if (closestBox != null) {
            selectBox(closestBox);
        } else {
            unselectAllBoxes();
            populateSummaryValuesForBox(fullScreenBackgroundBox);
        }
        if(!pointClickBeingHandled) clearPopovers();
        pointClickBeingHandled = false;
    }

    function isPointInBox(box, xVal, yVal) {

        var xMin = +box.attr("x");
        var xMax = xMin + +box.attr("width");
        var yMin = +box.attr("y");
        var yMax = yMin + +box.attr("height");

        return ((xVal <= xMax) && (xVal > xMin) && (yVal <= yMax) && (yVal > yMin));
    }

    function deleteSelectedBox() {
        var selectedBoxElement = d3.select(".selectedBox");

        if(selectedBoxElement[0][0] === null)
        {
            return;
        }

        var boxId = selectedBoxElement.attr("boxId");
        var boxIndexInArray = 0;
        for (var i = 0; i < boxesData.length; i++) {
            if (boxesData[i].boxId === boxId) boxIndexInArray = i;
        }

        boxesData.splice(boxIndexInArray, 1);
        d3.select(".selectedBox").remove();
        clearDiv(selectors.boxSummary);
        populateSummaryValuesForBox(fullScreenBackgroundBox);
        boxBool = false;
        vm.$store.commit('updateBoxBool', boxBool);
    }

    function zoomToSelectedBox() {
        var box = d3.select(".selectedBox");
        if(box === null)
        {
            return;
        }
        manualZoom(box);
        unselectAllBoxes();
        d3.selectAll(".zoomedBox").classed("zoomedBox",false);
        box.classed("zoomedBox", true);
        populateSummaryValuesForBox(fullScreenBackgroundBox);
    }

    /* Zoom */

    function resetZoom() {
        setDomain();
        svg.call(zoomListener.event);
        if (d3.selectAll(".zoomedBox").size() > 0) {
            d3.selectAll(".zoomedBox").classed("zoomedBox", false);
            populateSummaryValuesForBox(fullScreenBackgroundBox);
        }
    }

    function zoomHandler() {
        $(".axis").remove();
        container.select(".x.axis").call(axis.x);
        container.select(".y.axis").call(axis.y);

        renderData();
        renderBoxes();
        renderAxis();
    }


    function manualZoom(box) {
        if(box[0][0] === null)
        {
            return;
        }
        var xStartNew = +box.attr("x");
        var xEndNew = +xStartNew + +box.attr("width");

        var yStartNew = +box.attr("y") + +box.attr("height");
        var yEndNew = +box.attr("y");

        zoomListener.x(scales.x.domain([xStartNew, xEndNew].map(scales.x.invert).sort(function (a, b) { return a - b; })));
        zoomListener.y(scales.y.domain([yStartNew, yEndNew].map(scales.y.invert).sort(function (a, b) { return a - b; })));

        svg.call(zoomListener.event);
    }

    /* Pop up */

    function addPopUp(d) {

        clearPopovers();

        var dataForPoint = d.__data__;

        if (dataForPoint == null) return;

        var list = $("<ul>");

        for (var dimensionId in dataFile.valueDimensions) {
            var dimensionObject = dataFile.valueDimensions[dimensionId];
            if (!dimensionObject.includeInPopout) continue;

            var value = dataForPoint[dimensionObject.name];

            var item = $("<li>").html(dimensionObject.name + " " + formatValue(value, dimensionObject.valueScaling));
            list.append(item);
        }

        for (var dimensionId in dataFile.categoryDimensions) {
            var dimensionObject = dataFile.categoryDimensions[dimensionId];

            if (!dimensionObject.includeInPopout) continue;

            var value = dataForPoint[dimensionObject.name];

            var item = $("<li>").html(dimensionObject.name + " " + value);
            list.append(item);
        }

        $(d).popover({ title: dataForPoint["id"], content: function () { return "<ul>" + list.html() + "</ul>" }, container: "body", html: "true" });

        $(d).popover("show");
    }

    function clearPopovers() {
        $(".popover").popover("destroy");
    }

    /* Event handlers*/

    function registerEventHandlers() {
        window.onresize = handleResize;
        $("#summaryControlsSection li.minimise-summary").on("click", function (event) {
            $(".summaryValues").collapse("toggle");
            $("#summaryControlsSection li.minimise-summary i").toggleClass("fa-rotate-180");
            //$(".summaryValues").on("shown.bs.collapse hidden.bs.collapse", function (event) {
                setFilterSectionMaxHeight();
            //});
        });
    }

    function handleResize() {
        clearDiv(selectors.mainChartArea);

        animationDuration = 0;
        loadChart();
        animationDuration = defaultAnimationDuration;
    }

    function handleMouseUp() {
        if (boxSelection) {
            mouseUpBoxSelect(this);
        }
    }

    function handleMouseDown() {
        if (boxSelection) {
            mouseDownBoxSelect(this);
        }
    }

    function disableUserZoom() {
        svg.on("mousedown.zoom", null);
        svg.on("mousemove.zoom", null);
        svg.on("dblclick.zoom", null);
        svg.on("touchstart.zoom", null);
        svg.on("wheel.zoom", null);
        svg.on("mousewheel.zoom", null);
        svg.on("MozMousePixelScroll.zoom", null);
    }


    /* Add text */

    function addSummaryText(title, value) {

        var row = $("<div>").addClass("row");

        var titleDiv = $("<div>").addClass("col-md-8");
        titleDiv.html(title);
        row.append(titleDiv);
        var valDiv = $("<div>").addClass("col-md-4 valueColumn");
        valDiv.html(value);
        row.append(valDiv);

        // $(selectors.boxSummary).append(row);
    }

    function setFilterSectionMaxHeight() {
        // if (!summaryValuesHeight) summaryValuesHeight = $(selectors.summaryValues).outerHeight(true);

        if ($(window).width() < 992) {
            categoryFilterControl.setMaxHeight();
            return;
        }

        var remainingHeight = $(selectors.inputPanel).outerHeight(true)
            - $("#logo").outerHeight(true)
            - $(selectors.inputHeader).outerHeight(true)
            - $(selectors.inputSection).outerHeight(true)
            - $("#summaryBox").outerHeight(true);
        if ($(selectors.summaryValues).attr("aria-expanded") === "true") remainingHeight -= summaryValuesHeight;
        categoryFilterControl.setMaxHeight(remainingHeight);
    }
    function isBoxSelected() {
        var test = d3.select(".selectedBox");
        return test;
    }

    /* Static functions */

    window.Loader = {
        loadAll: loadAll,
        updateForFilter: renderData
    }

/*********** </charting.js> ***********/

export default {
    rAdditionalSizeOptions: rAdditionalSizeOptions,
    draw: function (_data) {
        dataFile = _data;
        loadAll();
        plotChart();
        vm.$store.commit('updateChartFilter', filterOptions);
    },
    zoomIn: function () {
        zoomToSelectedBox();
    },
    zoomOut: function () {
        resetZoom();
    },
    deleteBox: function () {
        deleteSelectedBox();
    },
    onAxisChnaged: function () {
        onAxisChnaged();
    },
    filterChart: function () {
        plotChart();
    }
};


// WEBPACK FOOTER //
// ./src/components/eXcYteD3.js